import { Box, Link, Typography, alpha } from '@mui/material';
import { ImageBlock } from 'types/blog';

// ==============================|| 記事中の画像 ||============================== //
//
// 様式や記入例など、文章で説明するより見せたほうが早いものに使う。
//
// 幅いっぱいに出すが、元が横長のA4様式なので細部は縮むと読めない。
// そのため出典元の資料を開く導線を添える(原本にあたれるほうが読者に親切で、
// 公的資料を引用する条件である出典明示も同時に満たせる)。
// 添える文言でファイル形式を名指ししないこと。creditUrl の先がPDFとは限らず、
// 自作の図(SVG)のように creditUrl を持たない画像もある。
//
// width / height を img に渡しているのは、読み込み前にブラウザが場所を確保できるようにするため。
// これが無いと画像が入った瞬間に下の本文が押し下げられ、読んでいる行が飛ぶ。
// loading="lazy" は、記事の下のほうにある画像を最初に読み込ませないための指定。

const primaryColor = '#2aa1af';

const ArticleImage = ({ block }: { block: ImageBlock }) => (
    <Box component="figure" sx={{ m: 0, my: { xs: 4, md: 5 } }}>
        {/* 様式は横長で文字が細かく、記事の幅に収めると読み切れない。
            出典元の資料へ飛べるようにして、拡大して見たい人の逃げ道を用意する。
            出典元が無い画像(自社で作った図など)のときは、ただの画像として出す */}
        <Box
            {...(block.creditUrl
                ? { component: 'a', href: block.creditUrl, target: '_blank', rel: 'noopener noreferrer' }
                : {})}
            sx={{
                display: 'block',
                borderRadius: 2,
                overflow: 'hidden',
                border: `1px solid ${alpha('#111827', 0.12)}`,
                bgcolor: '#fff',
                lineHeight: 0,
                transition: 'border-color .2s ease',
                ...(block.creditUrl ? { '&:hover': { borderColor: alpha(primaryColor, 0.55) } } : {})
            }}
        >
            {/* ここは MUI の Box ではなく素の img を使う。
                Box に width / height を渡すと、MUI がスタイル指定(CSSの幅・高さ)として
                受け取ってしまい、HTMLの width / height 属性が出力されない。
                属性が無いとブラウザが縦横比を先に知れず、レイアウトシフト対策にならない。 */}
            <img
                src={block.src}
                alt={block.alt}
                width={block.width}
                height={block.height}
                loading="lazy"
                decoding="async"
                style={{ width: '100%', height: 'auto', display: 'block' }}
            />
        </Box>

        {(block.caption || block.credit) && (
            <Typography component="figcaption" sx={{ mt: 1.25, color: '#6b7280', fontSize: '0.8rem', lineHeight: 1.8 }}>
                {block.caption}
                {block.creditUrl && (
                    <Box component="span" sx={{ display: 'block', color: '#9ca3af', mt: 0.5 }}>
                        画像をクリックすると、出典元の資料が開きます。
                    </Box>
                )}
                {block.credit && (
                    <Box component="span" sx={{ display: 'block', color: '#9ca3af', mt: 0.5 }}>
                        出典：
                        {block.creditUrl ? (
                            <Link href={block.creditUrl} target="_blank" rel="noopener noreferrer" underline="hover" sx={{ color: primaryColor, fontWeight: 600 }}>
                                {block.credit}
                            </Link>
                        ) : (
                            block.credit
                        )}
                    </Box>
                )}
            </Typography>
        )}
    </Box>
);

export default ArticleImage;
